import React, { useState, useContext } from "react";
import InfoIcon from "../../../assets/icn/info.png";
import "swiper/css";
import Image from "next/image";
import { ModalProvider } from "../../../contexts/StockPageModal";

import { CardTitleBtn } from "@/elements/Button/Button";
import FinancialCard from "@/elements/FinancialIndCards/FinancialCard";
import { capitalized } from "@/lib/utils";
import { isMobile } from "react-device-detect";

const modalData = [
    {
        heading: `Return on equity`,
        details: `ROE helps you understand how efficiently a firm is using its investors' money to generate profits`
    },
    {
        heading: `Earning per share`,
        details: `Earnings per share is a figure describing a company's profit per outstanding share of stock`
    },
    {
        heading: `Return on capital employed`,
        details: `ROCE tells you the amount of profit a company is generating per 1 rupee of the capital employed`
    },
    {
        heading: `Debt to equity`,
        details: `D/E Ratio Compares a company's total liabilities to its shareholder equity and can be used to evaluate how much leverage a company is using`
    },
    {
        heading: `Book value per share`,
        details: `takes the ratio of a firm's common equity divided by its number of shares outstanding`
    },
    {
        heading: `Return on asset`,
        details: `ROA measures how much profit a business is generating from its capital`
    },
    {
        heading: `Debt to asset ratio`,
        details: `Debt to asset ratio shows you how much business is owned by creditors compared with how much of the company's asset is owned by shareholders`
    }
];

const financialIndicatorCard = [
    {
        heading: `Return on equity`,
        indicator: "ROE",
        metric: `%`,
        pos: 1
    },
    {
        heading: `Return on asset`,
        indicator: "ROA",
        metric: `%`,
        pos: 1
    },
    {
        heading: `Earning per share`,
        indicator: "EPS",
        metric: `₹`,
        pos: 0
    },
    {
        heading: `Debt to equity`,
        indicator: "ROCE",
        metric: `%`,
        pos: 0
    },
    {
        heading: `Debt to asset ratio`,
        indicator: "DTAR",
        metric: ``,
        pos: 1
    }
];

function FinancialIndicator({ name, symbol, isPaidUserPage }) {
    const modal = useContext(ModalProvider);

    const [finIndicator, setFinIndicator] = useState(0);

    const openModalHandler = () => {
        modal.setTitle("Financial indicators");
        modal.setModalData(modalData);
        modal.setModal(true);
    };

    const handleIndicatorChange = (index) => {
        setFinIndicator(index);
    };

    return (
        <div className="relative w-full lg:w-[calc(50%-8px)]" id="financial_indicators">
            <div className="font-Inter text-sm lg:text-base text-black flex flex-row justify-between mx-4 lg:mx-0 mt-6 mb-4 font-semibold md:mt-10">
                <div className="flex flex-row gap-2">
                    <h2 className="mr-4 line-clamp-1">
                        Financial indicators {!isPaidUserPage && `for ${symbol} Share`}
                    </h2>
                    <button className="w-4 h-4 self-center" onClick={openModalHandler}>
                        <Image src={InfoIcon} alt="info" className="w-4 min-w-4 h-4 self-center" />
                    </button>
                </div>
            </div>
            <div className="rounded-xl border border-[#E5E5E5] mx-4 lg:mx-0 py-3 ">
                <div className="font-Inter text-[12px] flex flex-row items-center justify-start overflow-x-auto no-scrollbar gap-2 lg:gap-3 px-3">
                    {financialIndicatorCard?.map((ele, i) => (
                        <CardTitleBtn
                            key={i}
                            active={finIndicator === i}
                            text={ele.indicator}
                            onClick={() => handleIndicatorChange(i)}
                        />
                    ))}
                    {/* <p className="text-[#747474] text-xs lg:text-sm font-medium whitespace-nowrap ml-auto">
                        Value in Cr.
                    </p> */}
                </div>
                <FinancialCard
                    number={finIndicator + 1}
                    name={name}
                    indicator={financialIndicatorCard[finIndicator].indicator}
                    heading={financialIndicatorCard[finIndicator].heading}
                    metric={financialIndicatorCard[finIndicator].metric}
                    pos={financialIndicatorCard[finIndicator].pos}
                />
            </div>
        </div>
    );
}

export default FinancialIndicator;
